<template>
  <div>
    <v-row>
      <v-col 
        cols="12"
        md="7"
        class="py-0">
        <v-tabs
          v-model="selected.menu"
          fixed-tabs
          slider-size="4"
          :color="set_color"
          :background-color="set_color_rgb_soft"
          style="border-radius: 8px 8px 0px 0px !important;">
          <v-tab
            v-for="(item, index) in menu"
            :key="index"
            @click="changeQuery(item.link)">
            <div
              class="text-capitalize"
              :class="selected.menu === index ? 'font-weight-bold' : ''">
              {{ item.text }}
            </div>
          </v-tab>
        </v-tabs>
      </v-col>

      <v-col
        cols="12"
        md="1"
        class="py-0">
      </v-col>

      <v-col
        cols="12"
        md="4"
        class="py-0">
        <v-btn
          block
          height="48"
          elevation="0"
          class="text-capitalize"
          style="border: 1px solid #E0E0E0; border-radius: 8px 8px 0px 0px; border-bottom: 0px;">
          <div
            style="opacity: 60%;">
            Bobot Indikator Pelaksanaan Tugas Utama 0 / 55
          </div>
        </v-btn>
      </v-col>
    </v-row>

    <div>
      <Ketepatan v-if="selected.menu === 0" />

      <Penilaian v-if="selected.menu === 1" />

      <Skor v-if="selected.menu === 2" />
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },

        menu: [
          {
            text: 'Ketepatan Pekerjaan',
            link: '/evaluation/officer/main?menu=0'
          },
          {
            text: 'Penilaian Atasan Langsung',
            link: '/evaluation/officer/main?menu=1'
          },
          {
            text: 'Skor Presensi',
            link: '/evaluation/officer/main?menu=2'
          }
        ],

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Ketepatan: () => import(/* webpackPrefetch: true */ '@/components/main_task/ketepatan_pekerjaan.vue'),
      Penilaian: () => import(/* webpackPrefetch: true */ '@/components/main_task/penilaian_atasan.vue'),
      Skor: () => import(/* webpackPrefetch: true */ '@/components/main_task/skor_presensi.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.1)`
      }
    },
    watch: {
      
    },
    beforeMount () {
      this.changeLink(this.$route.query.menu)
    },
    mounted () {
      
    },
    methods: {
      changeLink (query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          this.selected.menu = parseInt(query)
        }
      },
      changeQuery (link) {
        this.$router.push(link)
      }
    }
  }
</script>